export default {
  title: 'Articole populare',
  list: {
    empty_list: {
      title: 'Niciun articol popular încă.',
    },
    fields: {
      name: 'Nume',
      orders: 'Comenzi',
      sales: 'Vânzări',
    },
  },
};
